<template>
  <b-container fluid>
<b-row>
<b-col md="12">
<b-card style="border: 2px solid">
            <h4>{{ $t('hospital_information.patient_registration') }} {{ $t('globalTrans.search') }}</h4>
            <b-row>
                <b-col lg="9" sm="9">
                    <ValidationProvider name="Hospital Name" vid="hospital_id">
                      <b-form-group
                        class="row"
                        label-cols-sm="12"
                        label-for="hospital_id"
                        slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('hospital_configuration.hospital_name')}}
                        </template>
                        <v-select name="Bank"
                            v-model="searchx.hospital_id"
                            label="text"
                            :reduce="item => item.value"
                            :options= hospitalList
                            :placeholder="$t('globalTrans.select')"
                            :filter-by="myFilter"
                        />
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12">
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="4"
                    :label="$t('hospital_information.form_no')"
                    label-for="auto_id"
                    >
                    <b-form-input
                        id="auto_id"
                        v-model="searchx.auto_id"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('hospital_information.patient_name')"
                    label-for="designation"
                    >
                    <b-form-input
                        id="designation"
                        v-model="searchx.patient_name"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="7" lg="7" xl="3">
                    <b-form-group
                    class="row"
                    label-cols-sm="5"
                    :label="$t('externalUser.nid')"
                    label-for="designation"
                    >
                    <b-form-input
                        id="designation"
                        v-model="searchx.nid"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="12" lg="12" xl="12" class="text-right">
                    <b-button type="button" variant="primary" @click="loadSearchData">{{ $t('globalTrans.search')}}</b-button>
                </b-col>
            </b-row>
            <br>
            <b-overlay :show="unitLoad">
              <table class="table table-bordered">
                <tr class="bg-light">
                  <th>{{$t('hospital_information.sl')}}</th>
                  <th>{{$t('hospital_information.sl')}}</th>
                  <th>{{$t('globalTrans.name')}}</th>
                  <th>{{$t('externalUser.nid')}}</th>
                  <th>{{$t('externalUser.brs_no')}}</th>
                  <th>{{$t('globalTrans.phone_no')}}</th>
                  <th>{{$t('hospital_information.form_no')}}</th>
                </tr>
                <tr v-for="(item, index) in patientData" :key="index" @click="dataCopy(item)">
                  <td><input type="radio" id="html" name="fav_language" value="HTML"></td>
                  <td>{{ $n(index + 1) }}</td>
                  <td>{{ $i18n.locale === 'bn' ? item.patient_name_bn : item.patient_name }}</td>
                  <td>{{ item.nid }}</td>
                  <td>{{ item.brs_no }}</td>
                  <td>{{ item.phone_no }}</td>
                  <td>{{ item.auto_id }}</td>
                </tr>
              </table>
               </b-overlay>
</b-card>
</b-col>
</b-row>
<hr>
    <b-row>
      <b-col md="12">
        <b-card no-body>
          <ValidationObserver ref="form"  v-slot="{ handleSubmit, reset }">
            <b-form  @submit.prevent="handleSubmit(personal_submit)" @reset.prevent="reset" >
              <!-- patient type and search patinet data -->
              <b-row>
                <b-col md="4" lg="4">
                  <ValidationProvider name="Officer ID" vid="office_id" rules="required|min_value:1">
                    <b-form-group class="row" label-cols-sm="4" label-for="office_id" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.hospital_name')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                          plain
                          disabled
                          v-model="search.office_id"
                          :options="hospitalList"
                          id="office_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                 <b-col md="4" lg="4" v-if="patient_form.case_history_no !== 0">
                  <ValidationProvider name="Case History No" vid="case_history_no">
                    <b-form-group class="row" label-cols-sm="4" label-for="case_history_no" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.case_history_no')}}
                      </template>
                      <b-form-input
                          plain
                          v-model="patient_form.case_history_no"
                          disabled
                          id="case_history_no"
                          :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>{{patient_form.case_history_no}}
                          </template>
                      </b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                  <b-col md="4" lg="4">
                  <ValidationProvider name="Patient Type Id" vid="patient_type_id" rules="required">
                    <b-form-group class="row" label-cols-sm="4" label-for="patient_type_id" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.pat_type')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                          plain
                          disabled
                          v-model="search.patient_type_id"
                          :options="patientTypeList"
                          id="patient_type_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                        </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
                 <b-col md="4" lg="4" v-if="search.patient_type_id === 1">
                  <ValidationProvider name="Form No" vid="form_no" rules="required">
                    <b-form-group class="row" label-cols-sm="4" label-for="form_no" slot-scope="{ valid, errors }">
                      <template v-slot:label>
                        {{$t('social_service.form_no')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-input
                      disabled
                      v-model="search.auto_id"
                      :state="errors[0] ? false : (valid ? true : null)"
                      id="form_no"
                      @change="LoadRegisterdPatient(search.auto_id)"
                      >
                      </b-form-input>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      <p class="text-danger" v-if="isSearchInValid">
                        {{$t('social_service.invalid_form_no')}}
                      </p>
                    </b-form-group>
                  </ValidationProvider>
                </b-col>
              </b-row>
              <b-overlay :show="loadingPatient">
                <b-row style="border: 1px solid rgba(0, 0, 0, 0.125);padding:10px">
                  <!-- patient name bn -->
                  <b-col md="4">
                    <ValidationProvider name="Patient Name (Bn)" vid="patient_name_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="patient_name_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.patient_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="patient_name_bn"
                        disabled
                        v-model="patient_form.patient_name_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- patient name en -->
                  <b-col md="4">
                    <ValidationProvider name="Patient Name (En)" vid="patient_name" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="patient_name" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.patient_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="patient_name"
                        disabled
                        v-model="patient_form.patient_name"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- father name bn -->
                  <b-col md="4">
                    <ValidationProvider name="Father Name (Bn)" vid="father_name_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="father_name_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.father_name_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="father_name_bn"
                        disabled
                        v-model="patient_form.father_name_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- father name en -->
                  <b-col md="4">
                    <ValidationProvider name="Father Name (En)" vid="father_name" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="father_name" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.father_name_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="father_name"
                        disabled
                        v-model="patient_form.father_name"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- mother name bn -->
                  <b-col md="4">
                    <ValidationProvider name="Mother Name (Bn)" vid="mother_name_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="mother_name_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.mother_name_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="mother_name_bn"
                        disabled
                        v-model="patient_form.mother_name_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- mother name -->
                  <b-col md="4">
                    <ValidationProvider name="Mother Name (En)" vid="mother_name" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="mother_name" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.mother_name_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="mother_name"
                        disabled
                        v-model="patient_form.mother_name"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- id type -->
                  <b-col md="4">
                    <ValidationProvider name="Id Type" vid="ID Type">
                      <b-form-group class="row" label-cols-sm="6" label-for="id_type" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{ $t('social_service.choose_id_type') }}
                        </template>
                        <b-form-select
                            plain
                            disabled
                            v-model="patient_form.id_type"
                            :options="IdentityTypeList"
                            id="id_type"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- id no -->
                  <b-col md="4">
                    <ValidationProvider name="Id No" vid="id_no">
                      <b-form-group class="row" label-cols-sm="6" label-for="id_no" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.nid_no')}}
                        </template>
                        <b-form-input
                        type="number"
                        id="id_no"
                        disabled
                        v-model="patient_form.id_no"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- address start -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Area Type" vid="area_type_id" rules="required">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="area_type_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.area_type')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.area_type_id"
                          :options="areaTypeList"
                          id="area_type_id"
                          @change="getAreaTypeData(patient_form.area_type_id)"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Division -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="Division" vid="division_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="division_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.division')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="patient_form.division_id"
                        :options="divisionList"
                        id="division_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                        :disabled="search.patient_type_id === 1 ? true : false"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- District -->
                  <b-col sm="4" lg="4" xl="4" md="4">
                    <ValidationProvider name="District" vid="district_id" rules="required">
                      <b-form-group
                        class="row"
                        label-cols-sm="6"
                        label-for="district_id"
                        slot-scope="{ valid, errors }"
                      >
                      <template v-slot:label>
                        {{$t('hospital_public_panel.district')}} <span class="text-danger">*</span>
                      </template>
                      <b-form-select
                        plain
                        v-model="patient_form.district_id"
                        :options="districtList"
                        id="district_id"
                        :state="errors[0] ? false : (valid ? true : null)"
                        :disabled="search.patient_type_id === 1 ? true : false"
                      >
                      <template v-slot:first>
                        <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                      </template>
                      </b-form-select>
                      <div class="invalid-feedback">
                        {{ errors[0] }}
                      </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- City Corporation -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-show="cityCorporationShow">
                    <ValidationProvider name="City Corporation" vid="city_corporation_id" :rules="`${cityCorporationShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="city_corporation_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.city_corporation')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.city_corporation_id"
                          :options="cityCorporationList"
                          id="city_corporation_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Upazila -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-show="upazilaShow">
                    <ValidationProvider name="Upazila" vid="upazilla_id" :rules="`${upazilaShow ? 'required' : ''}`">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="upazilla_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.upazila')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.upazilla_id"
                          :options="upazilaList"
                          id="upazilla_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Union -->
                  <b-col sm="4" lg="4" xl="4" md="4" v-show="unionShow">
                    <!-- <ValidationProvider name="Union" vid="union_id" :rules="`${unionShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Union" vid="union_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="union_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.union')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.union_id"
                          :options="unionList"
                          id="union_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Pourashava -->
                  <b-col xl="4" lg="4" sm="12" v-show="pourashavaShow">
                    <!-- <ValidationProvider name="Pourashava" vid="pauroshoba_id" :rules="`${pourashavaShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Pourashava" vid="pauroshoba_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="pauroshoba_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{$t('hospital_public_panel.pourashava')}}
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.pauroshoba_id"
                          :options="pauroshobaList"
                          id="pauroshoba_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Ward -->
                  <b-col xl="4" lg="4" sm="12" v-show="wardShow">
                    <!-- <ValidationProvider name="Ward" vid="ward_id" :rules="`${wardShow ? 'required|min_value:1' : ''}`"> -->
                    <ValidationProvider name="Ward" vid="ward_id" rules="">
                        <b-form-group
                          class="row"
                          label-cols-sm="6"
                          label-for="ward_id"
                          slot-scope="{ valid, errors }"
                        >
                        <template v-slot:label>
                          {{ $t('org_pro.ward') }}
                        </template>
                        <b-form-select
                          plain
                          v-model="patient_form.ward_id"
                          :options="wardList"
                          id="ward_id"
                          :state="errors[0] ? false : (valid ? true : null)"
                          :disabled="search.patient_type_id === 1 ? true : false"
                        >
                        <template v-slot:first>
                          <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                        </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                        </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- address end -->
                  <!-- gurdian name bn -->
                  <b-col md="4">
                    <ValidationProvider name="Patient Gurdian Name (Bn)" vid="guardian_name_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="guardian_name_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.patient_guar_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        disabled
                        id="guardian_name_bn"
                        v-model="patient_form.guardian_name_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- gurdian name en -->
                  <b-col md="4">
                    <ValidationProvider name="Patient Gurdian Name (En)" vid="guardian_name" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="guardian_name" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.patient_guar_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        disabled
                        id="guardian_name"
                        v-model="patient_form.guardian_name"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- relation bn -->
                  <b-col md="4">
                    <ValidationProvider name="Relation Bn" vid="relation_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="relation_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.relation_patient_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="relation_bn"
                        v-model="patient_form.relation_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- relation en -->
                  <b-col md="4">
                    <ValidationProvider name="Relation (En)" vid="relation" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="relation" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.relation_patient_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        id="relation"
                        v-model="patient_form.relation"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- age -->
                  <b-col md="4">
                    <ValidationProvider name="Age" vid="age" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="age" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.age')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="number"
                        id="age"
                        v-model="patient_form.age"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- occupation id -->
                    <b-col md="4">
                      <ValidationProvider name="Occupation" vid="occupation_id">
                        <b-form-group class="row" label-cols-sm="6" label-for="occupation_id" slot-scope="{ valid, errors }">
                          <template v-slot:label>
                            {{$t('globalTrans.occupation')}}
                          </template>
                          <b-form-select
                              plain
                              v-model="patient_form.occupation_id"
                              :options="subOccupationList"
                              id="occupation_id"
                              :state="errors[0] ? false : (valid ? true : null)"
                              >
                          <template v-slot:first>
                              <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                          </template>
                          </b-form-select>
                          <div class="invalid-feedback">
                            {{ errors[0] }}
                          </div>
                        </b-form-group>
                      </ValidationProvider>
                    </b-col>
                  <!-- occupation bn -->
                  <b-col md="4" v-if="patient_form.occupation_id == 12">
                    <ValidationProvider name="Occupation (Bn)" vid="occupation_bn">
                      <b-form-group class="row" label-cols-sm="6" label-for="occupation_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('hospital_information.occupation_bnn')}}
                        </template>
                        <b-form-input
                        v-model="patient_form.occupation_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- occupation en -->
                  <b-col md="4" v-if="patient_form.occupation_id == 12">
                    <ValidationProvider name="Occupation (En)" vid="occupation_en">
                      <b-form-group class="row" label-cols-sm="6" label-for="occupation_en" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('hospital_information.occupation_enn')}}
                        </template>
                        <b-form-input
                        type="text"
                        id="occupation_en"
                        v-model="patient_form.occupation"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- monthly income -->
                  <b-col md="4">
                    <ValidationProvider name="Monthly Income" vid="monthly_income" rules="min_value:100">
                      <b-form-group class="row" label-cols-sm="6" label-for="monthly_income" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.monthly_income')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="number"
                        id="monthly_income"
                        v-model="patient_form.monthly_income"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- marital status -->
                  <b-col md="4">
                    <ValidationProvider name="Marital Status" vid="marital_status" rules="required|min_value:1">
                      <b-form-group class="row" label-cols-sm="6" label-for="marital_status" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.mat_status')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-select
                            plain
                            v-model="patient_form.marital_status"
                            :options="maritalStatusList"
                            id="marital_status"
                            :state="errors[0] ? false : (valid ? true : null)"
                            >
                            <template v-slot:first>
                                <b-form-select-option :value="0">{{$t('globalTrans.select')}}</b-form-select-option>
                            </template>
                        </b-form-select>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Educational Qualification (Bn) -->
                  <b-col md="4">
                    <ValidationProvider name="Educational Qualification (Bn)" vid="qualification_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="qualification_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.edu_quali_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        id="qualification_bn"
                        v-model="patient_form.qualification_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- Educational Qualification (En) -->
                  <b-col md="4">
                    <ValidationProvider name="Educational Qualification (En)" vid="qualification" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="qualification" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.edu_quali_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="qualification"
                        v-model="patient_form.qualification"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- religion_bn -->
                  <b-col md="4">
                    <ValidationProvider name="Religion Bn" vid="religion_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="religion_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.religion_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="religion_bn"
                        v-model="patient_form.religion_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- religion_en -->
                  <b-col md="4">
                    <ValidationProvider name="Religion En" vid="religion" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="religion" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.religion_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="religion"
                        v-model="patient_form.religion"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- nationality_bn -->
                  <b-col md="4">
                    <ValidationProvider name="Nationality Bn" vid="nationality_bn" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="nationality_bn" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.nationality_bn')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        id="nationality_bn"
                        v-model="patient_form.nationality_bn"
                        :state="errors[0] ? false : (valid ? true : null)"
                        >
                        </b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                  <!-- nationality_en -->
                  <b-col md="4">
                    <ValidationProvider name="Nationality" vid="nationality" rules="required">
                      <b-form-group class="row" label-cols-sm="6" label-for="nationality" slot-scope="{ valid, errors }">
                        <template v-slot:label>
                          {{$t('social_service.nationality_en')}} <span class="text-danger">*</span>
                        </template>
                        <b-form-input
                        type="text"
                        id="nationality"
                        v-model="patient_form.nationality"
                        :state="errors[0] ? false : (valid ? true : null)"
                        ></b-form-input>
                        <div class="invalid-feedback">
                          {{ errors[0] }}
                        </div>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
              </b-overlay>
              </b-form>
            </ValidationObserver>
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { core } from '@/config/pluginInit'
import RestApi, { hospitalServiceBaseUrl } from '@/config/api_config'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { patientSearchList, PersonalInfoFormCaseHistory, patientDetailsApi, assignUserHospitalApi } from '../../../api/routes'
import StaticData from './static_data.js'
import flatpickr from 'flatpickr'

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },
  data () {
    return {
     searchx: {
          nid: '',
          hospital_id: '',
          auto_id: '',
          from_date: '',
          to_date: '',
          patient_name: ''

      },
      showIdType: 0,
      loadingPatient: false,
      isSearchInValid: false,
      ItemShow: false,
      cityCorporationShow: false,
      upazilaShow: false,
      unionShow: false,
      pourashavaShow: false,
      wardShow: false,
      unitLoad: false,
      rows: [],
      districtList: [],
      upazilaList: [],
      unionList: [],
      cityCorporationList: [],
      pauroshobaList: [],
      hospitalList: [],
      hospitalIds: [],
      userId: 0,
      wardList: [],
      patientData: []
    }
  },
  watch: {
    'searchx.hospital_id': function (newVal, oldVal) {
      this.search.office_id = this.searchx.hospital_id
    },
    'patient_form.regis_id': function (newVal, oldVal) {
      // this.districtList = this.getDistrictList(newVal)
    },
    'search.patient_type_id': function (newVal, oldVal) {
      this.patient_form.patient_type_id = newVal
      this.patient_form.office_id = this.search.office_id
      this.isSearchInValid = false
      this.resetPatientRegMains()
      this.getAreaTypeData(0)
    },
    'search.auto_id': function (newVal, oldVal) {
      if (this.$route.params.case_id) {
        if (newVal) {
          this.LoadRegisterdPatient(newVal)
        }
      }
    },
    'patient_form.division_id': function (newVal, oldVal) {
      this.districtList = this.getDistrictList(newVal)
    },
    'patient_form.district_id': function (newVal, oldVal) {
      this.cityCorporationList = this.getCityCorporationList(newVal)
      this.upazilaList = this.getUpazilaList(newVal)
    },
    'patient_form.upazila_id': function (newVal, oldVal) {
      this.unionList = this.getUnionList(newVal)
      this.pauroshobaList = this.getPauroshobaList(newVal)
    },
    'patient_form.city_corporation_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByCityCorportaion(newVal)
    },
    'patient_form.pauroshoba_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByPauroshoba(newVal)
    },
    'patient_form.union_id': function (newVal, oldVal) {
      this.wardList = this.getWardListByUnion(newVal)
    }
  },
  created () {
        this.search.patient_type_id = 1
        var officeId = this.$store.state.Auth.authUser.office_id
        if (officeId > 1) {
            this.userId = this.$store.state.Auth.authUser.user_id
            if (this.userId > 1) {
                this.getUserWiseHospital(this.userId)
            }
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
            this.hospitalList = this.getHospitalList()
        }
        if (this.$store.state.Auth.activeRoleId !== 1) {
            if (this.$store.state.Auth.authUser.is_org_admin !== 1) {
                this.getUserWiseHospital(this.userId)
            }
        }
    },
  mounted () {
    core.index()
    flatpickr('#datepicker', {})
  },
  computed: {
    patientTypeList: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.patientTypeList.filter(item => item.value === 1)
    },
    IdentityTypeList: function () {
      return this.$store.state.HospitalDisabilityService.commonObj.identityTypeList
    },
    subOccupationList: function () {
      return this.$store.state.commonObj.subOccupationList
    },
    areaTypeList: function () {
      const objectData = this.$store.state.commonObj.wardTypeList
        return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.id, text: obj.name_bn }
        } else {
          return { value: obj.id, text: obj.name }
        }
      })
    },
    genderList: function () {
      return StaticData.genderList(this)
    },
    // hospitalList () {
    //    return this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(hospital => hospital.status === 1)
    // },
    // officerInfo () {
      // const objectData = this.$store.state.Auth.authUser
      // const result = objectData.map((item) => {
      //   if (this.$i18n.locale === 'bn') {
      //     return { value: obj.id, text: obj.name_bn }
      //   } else {
      //     return { value: obj.id, text: obj.name }
      //   }
      // })
      // return result
    // },
    fatherEdutcationStatusList: function () {
      return StaticData.fatherEdutcationStatusList(this)
    },
    motherEducationStatusList: function () {
      return StaticData.motherEducationStatusList(this)
    },
    earningMemberList: function () {
      return StaticData.earningMemberList(this)
    },
    monthlyIncomeList: function () {
      return StaticData.monthlyIncomeList(this)
    },
    incomeSourceList: function () {
      return StaticData.incomeSourceList(this)
    },
    familyCategoryList: function () {
      return StaticData.familyCategoryList(this)
    },
    religionList: function () {
      return StaticData.religionList(this)
    },
    orgList: function () {
      return this.$store.state.commonObj.organizationProfileList
    },
    divisionList: function () {
      return this.$store.state.commonObj.divisionList.filter(item => item.status === 0)
    },
    maritalStatusList: function () {
      return this.$store.state.commonObj.maritalStatus
    }
  },
  props: ['patient_form', 'search'],
  methods: {
    dataCopy (item) {
        this.patient_form = item
        this.patient_form.case_history_no = 0
        this.search.auto_id = item.auto_id
        this.search.patient_type_id = 1
        this.patient_form.patient_type_id = 1
        this.patient_form.id_type = item.nid_or_brs
        this.patient_form.occupation_id = item.occupation_id
        this.patient_form.id_no = item.nid > 0 ? item.nid : item.brs_no
    },
    myFilter: (option, text, search) => {
        const temp = search.toLowerCase()
        return option.text_en.toLowerCase().indexOf(temp) > -1 ||
        option.text_bn.toLowerCase().indexOf(temp) > -1
    },
    async getUserWiseHospital (userId) {
        const params = Object.assign({ user_id: userId })
        const result = await RestApi.getData(hospitalServiceBaseUrl, assignUserHospitalApi, params)
        if (result.success) {
                this.hospitalIds = result.data
        } else {
            this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1).map((obj, key) => {
                this.hospitalIds.push(obj.value)
            })
        }
        this.hospitalList = this.getHospitalList()
        if (this.hospitalList.length) {
          this.searchx.hospital_id = this.hospitalList[0].value
        }
    },
    getHospitalList () {
            let hospitalList = this.$store.state.HospitalDisabilityService.commonObj.hospitalInfoList.filter(item => item.status === 1)
            if (this.hospitalIds.length > 0) {
            hospitalList = hospitalList.filter((p) => this.hospitalIds.includes(p.value))
            }
            this.hospitalLoad = false

            return hospitalList
        },
    async personal_submit () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      this.patient_form.office_id = this.search.office_id
      this.patient_form.case_main_id = parseInt(this.$route.params.case_id) > 0 ? parseInt(this.$route.params.case_id) : 0
      result = await RestApi.postData(hospitalServiceBaseUrl, PersonalInfoFormCaseHistory, this.patient_form)

      loadingState.listReload = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        this.$store.commit('HospitalDisabilityService/mutateCommonObj', { hasDropdownLoaded: false })
          this.$toast.success({
            title: 'Success',
            message: this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
          })
          return result
          } else {
            this.$toast.error({
                title: 'Error',
                message: this.$t('globalTrans.form_error_msg'),
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
    },
    async LoadRegisterdPatient (patientFormNo) {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      const patientTypeId = this.search.patient_type_id
      const officeId = this.search.office_id
      const loadingState = { loading: false, listReload: false }
      const params = {
        patient_type: patientTypeId,
        hospital_id: officeId,
        auto_id: patientFormNo
      }
      this.loadingPatient = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      const result = await RestApi.getData(hospitalServiceBaseUrl, patientDetailsApi, params)
      if (result.success) {
        this.dataCopy(result.case_data)
        if (result.iscase && result.ispatient) {
          this.patient_form = result.case_data
          this.patient_form.patient_type_id = patientTypeId
          this.patient_form.office_id = officeId
          // this.fillForm(this.patient_form.case_history_id)
          this.isSearchInValid = false
        } else {
        this.patient_form = result.patient_data
        this.patient_form.marital_status = 0
        this.patient_form.patient_type_id = patientTypeId
        this.patient_form.office_id = officeId
        this.isSearchInValid = false
        // this.fillForm(this.patient_form.case_history_id)
        }
      } else if (!result.success) {
        // this.patient_form.patient_type_id = patientTypeId
        // this.patient_form.office_id = officeId
        // this.isSearchInValid = true
        // this.resetPatientRegMains()
        // this.getAreaTypeData(0)
      }
      this.loadingPatient = false
    },
    async getPatientDetails () {
      this.$store.dispatch('mutateCommonProperties', { loading: true })
      let result = null
      const loadingState = { loading: false, listReload: false }
      result = await RestApi.postData(hospitalServiceBaseUrl, patientDetailsApi, this.patient_form)

      loadingState.listReload = true
      this.$store.dispatch('mutateCommonProperties', loadingState)
      if (result.success) {
        this.$store.commit('mutateAgriMarketingProperties', { hasDropdownLoaded: false })
          this.$toast.success({
            title: 'Success',
            message: this.$t('globalTrans.save_msg'),
            color: '#D6E09B'
          })
          return result
          } else {
            this.$toast.error({
                title: 'Error',
                message: this.$t('globalTrans.form_error_msg'),
                color: '#D6E09B'
            })
            this.$refs.form.setErrors(result.errors)
          }
    },
    resetAddress () {
        this.patient_form.division_id = 0
        this.patient_form.district_id = 0
        this.patient_form.city_corporation_id = 0
        this.patient_form.upazilla_id = 0
        this.patient_form.pauroshoba_id = 0
        this.patient_form.union_id = 0
        this.patient_form.ward_id = 0
    },
    getAreaTypeData (typeId) {
      this.ItemShow = true
      if (typeId === 1) {
        this.resetAddress()
        this.cityCorporationShow = true
        this.upazilaShow = false
        this.pourashavaShow = false
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 2) {
        this.resetAddress()
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = true
        this.unionShow = false
        this.wardShow = true
      } else if (typeId === 3) {
         /** Union */
         this.resetAddress()
        this.cityCorporationShow = false
        this.upazilaShow = true
        this.pourashavaShow = false
        this.unionShow = true
        this.wardShow = true
      } else {
        // Resetting The Form & Data
        this.patient_form.division_id = 0
        this.patient_form.district_id = 0
        this.patient_form.area_type_id = 0
        this.cityCorporationShow = false
        this.upazilaShow = false
        this.pourashavaShow = false
        this.unionShow = false
        this.wardShow = false
      }
    },
    getDistrictList (divisionId = null) {
      const districtList = this.$store.state.commonObj.districtList.filter(item => item.status === 0)
        if (divisionId) {
          return districtList.filter(district => district.division_id === divisionId)
        }
      return districtList
    },
    getUpazilaList (districtId = null) {
      const upazilaList = this.$store.state.commonObj.upazilaList.filter(item => item.status === 0)
        if (districtId) {
          return upazilaList.filter(upazila => upazila.district_id === districtId)
        }
      return upazilaList
    },
    getUnionList (upazilaId = null) {
      const unionList = this.$store.state.commonObj.unionList.filter(item => item.status === 0)
        if (upazilaId) {
          return unionList.filter(union => union.upazilla_id === upazilaId)
        }
      return unionList
    },
    getCityCorporationList (districtId) {
      const objectData = this.$store.state.commonObj.cityCorporationList.filter(item => item.status === 0 && item.district_id === districtId)
      return objectData.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text_en }
        }
      })
    },
    getPauroshobaList (upazillaId = null) {
      const objectData = this.$store.state.commonObj.pauroshobaList.filter(item => item.upazilla_id === upazillaId)
      if (upazillaId) {
          return objectData.map((obj, key) => {
          if (this.$i18n.locale === 'bn') {
            return { value: obj.value, text: obj.text_bn }
          } else {
            return { value: obj.value, text: obj.text_en }
          }
        })
      }
    },
    getWardListByCityCorportaion (cityCorpId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.city_corporation_id === cityCorpId && item.status === 0)
      return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByPauroshoba (pauroshobaId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.pauroshoba_id === pauroshobaId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    getWardListByUnion (unionId) {
      const objectData = this.$store.state.commonObj.wardList
      const wardObjectList = objectData.filter(item => item.union_id === unionId && item.status === 0)
        return wardObjectList.map((obj, key) => {
        if (this.$i18n.locale === 'bn') {
          return { value: obj.value, text: obj.text_bn }
        } else {
          return { value: obj.value, text: obj.text }
        }
      })
    },
    loadSearchData () {
        this.unitLoad = true
        const params = Object.assign({}, this.searchx)
        RestApi.getData(hospitalServiceBaseUrl, patientSearchList, params).then(response => {
            if (response.success) {
              this.patientData = response.data
              this.unitLoad = false
            } else {
              this.unitLoad = false
            }
        })
    },
    resetPatientRegMains () {
        this.patient_form.patient_name = ''
        this.patient_form.patient_name_bn = ''
        this.patient_form.father_name = ''
        this.patient_form.father_name_bn = ''
        this.patient_form.mother_name = ''
        this.patient_form.mother_name_bn = ''
        this.patient_form.type_id = 0
        this.patient_form.id_no = ''
        this.patient_form.guardian_name = ''
        this.patient_form.guardian_name_bn = ''
        this.patient_form.relation = ''
        this.patient_form.relation_bn = ''
        this.patient_form.gender = ''
        this.patient_form.age = ''
        this.patient_form.gender_id = 0
        this.patient_form.occupation_id = 0
        this.patient_form.occupation = ''
        this.patient_form.occupation_bn = ''
        this.patient_form.monthly_income = ''
        this.patient_form.marital_status = 0
        this.patient_form.qualification = ''
        this.patient_form.qualification_bn = ''
        this.patient_form.father_education_status = ''
        this.patient_form.mother_education_status = ''
        this.patient_form.earning_member = ''
        this.patient_form.monthly_family_income = ''
        this.patient_form.income_source = ''
        this.patient_form.family_category = ''
        this.patient_form.no_of_family_member = ''
        this.patient_form.religion = ''
        this.patient_form.religion_bn = ''
        this.patient_form.nationality = ''
        this.patient_form.nationality_bn = ''
    }
  }
}
</script>
